import { BuiltinBase } from '../BuiltinBase';
class One0Value extends BuiltinBase {
}
class One1Value extends BuiltinBase {
}
export const add = (builtins) => {
    builtins.addValue('one0', new One0Value());
    builtins.addValue('one1', new One1Value());
};

//# sourceMappingURL=index.js.map
